import EvaluationsScreen from "./evaluations.screen";

export default  EvaluationsScreen;